import { render, staticRenderFns } from "./SimplePin.vue?vue&type=template&id=b810ec10&"
import script from "./SimplePin.vue?vue&type=script&lang=js&"
export * from "./SimplePin.vue?vue&type=script&lang=js&"
import style0 from "./SimplePin.vue?vue&type=style&index=0&id=b810ec10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports